import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./logindesign.css";
import { useAuth } from './AuthContext';
import App from './App';
import LoginFailedModal from "./LoginFailedModal";
import { postLogin } from './apiService';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LoginForm = () => {
  const history = useHistory();
  const { isAuthenticated, login } = useAuth();
  const [companyCode, setCompanyCode]           = useState('');
  const [companyId, setCompanyId]               = useState('');
  const [branchId, setBranchId]                 = useState('');
  const [username, setUsername]                 = useState('');
  const [password, setPassword]                 = useState('');
  const [showPassword, setShowPassword]         = useState(false);
  const [loginFailed, setLoginFailed]           = useState(false);
  const [companyCodeValidated, setCompanyCodeValidated] = useState(false);
  const [companyName, setCompanyName]           = useState('');
  const [branchstate, setbranchstate]           = useState('');

  /* ── Branch code validation ─────────────────────────────── */
  const handleCompanyValidation = async () => {
    try {
      if (!companyCode.trim()) {
        toast.error('Branch code is required.', { position: toast.POSITION.TOP_CENTER });
        return;
      }

      const response = await postLogin('BranchLoginApi', { BranchCode: companyCode });

      if (response.responseCode === '1111') {
        setCompanyCodeValidated(true);
        setCompanyId(response.response_data.companyId);
        setBranchId(response.response_data.id);
        setCompanyName(response.response_data.name);
        setbranchstate(response.response_data.branchstate);
        setLoginFailed(false);
      } else {
        toast.error('Invalid Branch code', { position: toast.POSITION.TOP_CENTER });
      }
    } catch {
      toast.error('Branch login failed', { position: toast.POSITION.TOP_CENTER });
    }
  };

  /* ── Login ──────────────────────────────────────────────── */
  const handleLogin = async () => {
    try {
      if (!companyCodeValidated) throw new Error('Branch code validation is required.');

      const jwtToken    = await performLogin();
      const responseData = jwtDecode(jwtToken);
      const keysToRemove = [
        'iss', 'exp', 'ttp',
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
        'aud',
      ];
      const permissions = Object.keys(responseData).filter(
        (key) => key !== 'companyId' && key !== 'userId' && !keysToRemove.includes(key)
      );

      const isSuper = responseData.isSuperAdmin.toLowerCase() === 'true';

      if (!isSuper && parseInt(responseData.companyId, 10) !== companyId) {
        toast.error('Invalid User !', { position: toast.POSITION.TOP_CENTER });
        return;
      }

      login(
        responseData.companyId, responseData.branchId, responseData.userId,
        isSuper, responseData.superAdminCompanyId, companyName,
        permissions, jwtToken, responseData.roleName, branchstate
      );

      const redirectParam = new URLSearchParams(location.search).get('redirect');
      history.replace(redirectParam ? decodeURIComponent(redirectParam) : '/Home');
    } catch {
      toast.error('Login failed', { position: toast.POSITION.TOP_CENTER });
    }
  };

  const performLogin = async () => {
    const response = await postLogin('LoginApi', {
      UserName: username,
      Password: password,
      CompanyId: companyId,
      BranchId: branchId,
    });
    if (response.responseCode === '1111') return response.response_data.token;
    throw new Error(response.Message);
  };

  const closeModal = () => setLoginFailed(false);

  if (isAuthenticated) return <App />;

  return (
    <div className="containers">
      <ToastContainer />

      <div className="login-boxs">

        {/* Brand */}
        <div className="login-brand">
          <div className="login-brand-icon">
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </div>
        </div>

        <h2 className="HEADING">SIGN IN</h2>
        <p className="login-subtitle">Enter your credentials to continue</p>

        {/* ── Step 1 : Branch code ── */}
        {!companyCodeValidated && (
          <form onSubmit={(e) => { e.preventDefault(); handleCompanyValidation(); }}>
            <div className="cc">
              <label htmlFor="branchCode">Branch Code</label>
              <input
                id="branchCode"
                type="text"
                placeholder="Enter branch code"
                value={companyCode}
                onChange={(e) => setCompanyCode(e.target.value)}
                autoComplete="off"
                autoFocus
              />
            </div>
            <button className="lgn" type="submit">Continue</button>
          </form>
        )}

        {/* ── Step 2 : Credentials ── */}
        {companyCodeValidated && (
          <>
            <p className="welcome-message">Welcome — {companyName}</p>

            <div className="login-divider">
              <span /><p>sign in below</p><span />
            </div>

            <form onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
              <div className="em">
                <label htmlFor="username">Username</label>
                <input
                  id="username"
                  type="text"
                  placeholder="Enter username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                  autoFocus
                  required
                />
              </div>

              <div className="pwd">
                <label htmlFor="password">Password</label>
                <div className="password-input-wrapper">
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                  >
                    {showPassword ? (
                      /* eye-off */
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94
                          M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19
                          m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                        <line x1="1" y1="1" x2="23" y2="23" />
                      </svg>
                    ) : (
                      /* eye */
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              <button className="lgn" type="submit">Login</button>
            </form>
          </>
        )}
      </div>

      {loginFailed && <LoginFailedModal onClose={closeModal} />}
    </div>
  );
};

export default LoginForm;
